<div class="full-grow-no-shrink-no-basis">
  <div class="orbitax-services-content simple-scroll full-grow-no-shrink-no-basis">
    <dl>
      <dt *ngIf="dueDateReturnDetails.hasOwnProperty('ReturnId')">Return ID</dt>
      <dd *ngIf="dueDateReturnDetails.hasOwnProperty('ReturnId')"> {{dueDateReturnDetails.ReturnId}} </dd>
      <dt *ngIf="dueDateReturnDetails.hasOwnProperty('ReturnType')">Return Type</dt>
      <dd *ngIf="dueDateReturnDetails.hasOwnProperty('ReturnType')"> {{dueDateReturnDetails.ReturnType}} </dd>
      <dt *ngIf="dueDateReturnDetails.hasOwnProperty('Jurisdiction')">Jurisdiction</dt>
      <dd *ngIf="dueDateReturnDetails.hasOwnProperty('Jurisdiction')"> {{dueDateReturnDetails.Jurisdiction}} </dd>
      <dt *ngIf="dueDateReturnDetails.hasOwnProperty('OccurrenceDisplayText')">Occurrence</dt>
      <dd
        *ngIf="dueDateReturnDetails.hasOwnProperty('OccurrenceDisplayText')"> {{dueDateReturnDetails.OccurrenceDisplayText}} </dd>
      <dt *ngIf="dueDateReturnDetails.hasOwnProperty('ReturnFormTitle')">Form Title</dt>
      <dd *ngIf="dueDateReturnDetails.hasOwnProperty('ReturnFormTitle')"> {{dueDateReturnDetails.ReturnFormTitle}} </dd>
      <dt
        *ngIf="dueDateReturnDetails.hasOwnProperty('EntityName') && dueDateReturnDetails.hasOwnProperty('ConsolidatedEntities')">
        Reporting Entity
      </dt>
      <dd
        *ngIf="dueDateReturnDetails.hasOwnProperty('EntityName') && dueDateReturnDetails.hasOwnProperty('ConsolidatedEntities')"> {{dueDateReturnDetails.EntityName}} </dd>
      <dt *ngIf="dueDateReturnDetails.hasOwnProperty('ConsolidatedEntities')">Consolidated Entities</dt>
      <dd
        *ngIf="dueDateReturnDetails.hasOwnProperty('ConsolidatedEntities')"> {{dueDateReturnDetails.ConsolidatedEntities}} </dd>
    </dl>
  </div>
</div>



